import React from 'react';
import { CProvider } from '@dark-portal/react-components';
import { Router } from '@/src/features/app/features/router/Router';
import { IdentityContextProvider } from '@/src/features/app/features/identity/store/Provider';
import { IdentityNavigator } from '@/src/features/domain/IdentityNavigator';
import { ENV } from '@/src/.env';
import i18n from 'i18next';

import '../../i18n';
import './App.sass';

export function App() {
  return (
    <CProvider locale={i18n.language}>
      <IdentityContextProvider config={{
        apiUrl: ENV.API_URL,
        onLogout: () => IdentityNavigator.goToLoginPage(),
        onUnauthenticated: () => IdentityNavigator.goToLoginPage(),
        onAuthenticated: () => IdentityNavigator.goToAuthenticatedPage(),
      }}>
        <Router/>
      </IdentityContextProvider>
    </CProvider>
  );
}
